import React from 'react';
import {
  View,
  TouchableOpacity
} from 'react-native';
import PropTypes from 'prop-types';

const ButtonText = ({ children, onPress, propsContainerStyle}) => {
  return(
    <View style={propsContainerStyle}>
      <TouchableOpacity onPress={onPress}>
        {children}
      </TouchableOpacity>
    </View>
  )
};

ButtonText.propTypes = {
    children: PropTypes.element.isRequired,
    onPress: PropTypes.func.isRequired,
    propsContainerStyle: PropTypes.object
};

export { ButtonText };